module.exports = __webpack_public_path__ + "82f96287fad815e4d4dbca9129c87d8b.svg";